








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppUserHistoryEditModel, AppUserVacationHistoryEditModel } from "@/services/api/nswag/stapiclient_generated";
import { stAppUserHistoryApi, stAppUserVacationHistoryApi } from "@/services/st-api";
import AppUserVacationHistoryEdit from '@/views/User/VacationHistory/AppUserVacationHistoryEdit.vue';
import { DateTime } from 'luxon';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';
import { ObjectEditor } from "@/utlitities/helper";

@Component({
  components: {
    StCurrencyInput,
    AppUserVacationHistoryEdit,
  },
})
export default class AppUserVacationHistory extends Vue {
  @Prop() appUserId!: number;
  @Prop() value!: AppUserVacationHistoryEditModel[];

  historyItems: ObjectEditor<AppUserVacationHistoryEditModel>[] = [];

  async mounted() {
    let unwatch = this.$watch('value', ()=>{
      this.value.forEach(x=>{
        this.historyItems.push(new ObjectEditor<AppUserVacationHistoryEditModel>(x));
        unwatch();
      });
    });
  }

  saveItem(item: ObjectEditor<AppUserVacationHistoryEditModel>){
    item.editMode = false;
    this.updateOutside();
  }

  cancel(item: ObjectEditor<AppUserHistoryEditModel>, index: number){
    if(item.isNew){
      this.remove(index);
    }else{
      item.reset();
    }
  }

  remove(index: number) {
    this.historyItems.splice(index, 1);
    this.updateOutside();
  }

  async updateOutside(){
    this.$emit('input', this.historyItems.map(x=>x.val));
    await this.$nextTick();
    this.historyItems = [];
    this.value.forEach(x=>{
      this.historyItems.push(new ObjectEditor<AppUserVacationHistoryEditModel>(x));
    });
  }

  get years(): any[] {
    let arr: any[] = [];
    for (let i = DateTime.local().year + 5; i > DateTime.local().year - 3; i--) {
      arr.push({ id: i, description: i.toString() });
    }
    return arr;
  }

  get isEditingItem() {
    return this.historyItems.filter((_) => _.editMode).length > 0;
  }

  async addNewItem() {
    let newItem = await stAppUserVacationHistoryApi.getNew(this.appUserId);
    let newHistoryItem = new ObjectEditor<AppUserHistoryEditModel>(newItem);
    newHistoryItem.editMode = true;
    newHistoryItem.isNew = true;
    this.historyItems.unshift(newHistoryItem);
  }
}
